import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { books } from "../../../data";
import Book from "../ui/Book";

const BookDetails = ({ onAddToCart }) => {
  const { id } = useParams();
  const [addedToCart, setAddedToCart] = useState(false);
  const book = books.find((item) => item.id === Number(id));

  if (!book) {
    return (
      <main id="books__main" className="container">
        <div className="row">
          <h1>Book not found</h1>
          <a href="/books">Return to all books</a>
        </div>
      </main>
    );
  }

  const recommendedBooks = books
    .filter((item) => item.id !== book.id)
    .slice(0, 4);

  function handleAddToCart() {
    onAddToCart(book);
    setAddedToCart(true);
  }

  return (
    <main id="books__main">
      <div className="container container__book--selected">
        <div className="row">
          <a href="/books" className="book__selected--link">
            Back to all books
          </a>
          <div className="book__selected">
            <figure className="book__selected--figure">
              <img
                src={book.url}
                alt={`${book.title} cover`}
                className="book__selected--img"
              />
            </figure>
            <div className="book__selected--description">
              <h1 className="book__selected--title">{book.title}</h1>
              <div
                className="book__ratings"
                aria-label={`${book.rating} out of 5 stars`}
              >
                {Array(Math.floor(book.rating))
                  .fill()
                  .map((_, index) => (
                    <FontAwesomeIcon key={index} icon="star" />
                  ))}
                {book.rating % 1 !== 0 && <FontAwesomeIcon icon="star-half" />}
                <span> {book.rating.toFixed(1)}</span>
              </div>
              <div className="book__summary">
                <h2 className="book__summary--title">Summary</h2>
                <p className="book__summary--para">{book.summary}</p>
              </div>
              <div className="book__price">
                {book.salePrice != null ? (
                  <>
                    <span className="book__price--normal">
                      ${Number(book.originalPrice).toFixed(2)}
                    </span>
                    ${Number(book.salePrice).toFixed(2)}
                  </>
                ) : (
                  `$${Number(book.originalPrice).toFixed(2)}`
                )}
              </div>
              <button className="btn" onClick={handleAddToCart}>
                Add to Cart
              </button>
              <p role="status" aria-live="polite">
                {addedToCart ? "Added to cart" : ""}
              </p>
            </div>
          </div>
        </div>
      </div>
      <section className="container">
        <div className="row">
          <h2 className="section__title">Recommended Books</h2>
          <div className="books">
            {recommendedBooks.map((recommendedBook) => (
              <Book
                key={recommendedBook.id}
                id={recommendedBook.id}
                imgSrc={recommendedBook.url}
                title={recommendedBook.title}
                rating={recommendedBook.rating}
                normalPrice={recommendedBook.originalPrice}
                salePrice={recommendedBook.salePrice}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default BookDetails;
